import React from 'react'

import Layout from '../layouts/zh'
import SEO from '../components/seo'

import Bubble from '../components/Bubble'
import IntroBox from '../components/IntroBox'
import Testimonial from '../components/Testimonial'
import VideoButton from '../components/VideoButton'

const IndexPage = (props) => (
  <Layout location={props.location}>
    <SEO title="校園發展" />

    <div
      className="bg-banner-30 bg-center bg-cover"
      style={{ backgroundImage: `url(/AnnualReport2017-2018/images/bg-campus.jpg)`, minHeight: '200px' }}
      id="continuous-optimisation"
    >
      <div className="absolute inset-0 py-12">
        <div className="container" data-aos="fade-up" data-aos-delay={400} data-aos-duration={1200}>
          <Bubble className="w-full md:w-1/2"
            title="持續優化"
            subtitle=""
          >
          </Bubble>
        </div>
      </div>
    </div>

    <div className="py-8">
      <div className="container">
        <div className="flex flex-row flex-wrap" data-aos="fade-up" data-aos-delay={850}>
          <div className="w-full flex">
            <div className="text-left mx-auto text-sm md:text-base font-normal text-justify">
              <p className="mb-4">優越的校園設施有助師生學術及個人發展，因此旅遊學院一直持續完善校園設施。重視可持續發展是學院一直遵循的原則，力求為師生教學和學習提供舒適的環境。學院將豐富的學術資源、融洽的校園氛圍和舒適的住宿環境相結合，提升學生及教職人員的校園體驗。</p>
              <p className="mb-4">學生可享用專業的培訓設施，包括設備先進的電腦室、烹飪課室、教學餐廳和教學酒店。學院還設有兩所圖書館，以及提供電子資訊服務和電腦設備。</p>
              <p className="mb-4">在2017/18學年，旅遊學院繼續改善和優化望廈和氹仔校區的設施。望廈校區的望廈迎賓館現正進行翻新工程，其設施將得到升級。氹仔校區方面，新教學酒店工程的設計及規劃工作亦已啟動；展望樓更換了兩組大型的中央冷凍主機以優化校區的空調設備；東亞樓除了繼續完善學生宿舍各樓層的配套設施及環境外，亦於九樓增設了學生溫習室和餐飲區。</p>
              <p className="mb-4">另外，各校舍逐步提升無障礙通用設施。校園服務部並於2018年4月成功通過ISO 9001:2015質量管理體系國際認證審核，持續優化部門運作以提升設施管理和各類校園服務效果。</p>
              <p><VideoButton url="https://player.youku.com/embed/XMzU5NzAzNzQ3Ng==" /></p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="bg-gray-200 py-8 md:py-12" id="green-and-healthy-campus">
      <div className="container">
        <div className="w-full mb-8 flex" data-aos="fade-up">
          <IntroBox className="mx-2 text-sm md:text-base h-full"
            title="綠色健康校園"
            image="/images/campus/5.1.2.jpg"
            textClassName="pl-0 md:pl-8"
          >
            <p className="mb-4">過去一年，學院持續加強學生及教職員的環保及職安健意識，全體師生一起構建綠色健康校園。</p>
            <p className="mb-4">學院連續第六年舉行“健康綠色體驗月”，主要涵蓋健康、安全及環保三方面。其中環保方面則大力推動減少耗電量、耗水量、列印量以及減少廚餘和垃圾量。“第六屆健康綠色體驗月”活動內容包括“你今日拯救地球未?”、“廚餘清潔酵素DIY工作坊”、“生態瓶DIY工作坊”、“剩食變果醬工作坊”、“微觀景盆栽DIY工作坊”、“IFT熄燈一小時及無電梯日”、“惜食兵團”，並有由學生會主辦的“Green O Camp & Green O Night”，由酒店管理二年級學生主理的“環保工作坊@ 望廈迎賓館”、“健康知識講座”、“防火安全知識講座”等，參加人數超過1,900人次。</p>
            <p className="mb-4">安全方面，學院除了進行各部門的意外、化學品洩漏及校園火警等演習外，亦舉行了健康及防火講座。相關演習的規格亦進一步提升，更加符合學院持續發展的要求。</p>
            <p>學院於暑假期間邀請了司法警察局為兩個校區進行校園安全巡查，以便優化的各項安全設施；此外，學院亦派員參加了“災難防範及應變”講座及參與由勞工局主辦的工作間急救護理常識課程，相關課程有效提升了員工的防災意識及應變能力。</p>
          </IntroBox>
        </div>
      </div>
    </div>

    <div className="py-8 md:pt-12 pb-4" id="passage-to-success">
      <div className="container flex">
        <div className="w-full" data-aos="flip-down">
          <h4 className="text-xl md:text-2xl text-indigo-700 mb-2">走向成功</h4>
          <div className="text-left mx-auto text-sm md:text-base font-normal text-justify">
            <p>旅遊學院教學特色之一在於為學生提供校內的實習機會。為了讓學生獲得旅遊及酒店服務的實踐經驗，旅遊學院望廈校區設有兩所實習單位，包括望廈迎賓館與教學餐廳，均對外開放。為學生提供專業的培訓環境，模擬真實職場，提供與真實賓客互動的寶貴機會。</p>
          </div>
        </div>
      </div>
    </div>

    <div className="py-8 md:py-12" id="pousada-de-mong-ha">
      <div className="container flex flex-wrap">
        <div className="w-full lg:w-1/3" data-aos="fade-right">
          <div className="inset-0">
            <img src="/AnnualReport2017-2018/images/campus/5.1.3.jpg" alt="IFT" className="object-cover object-bottom h-full w-full shadow-xl rounded-sm" />
          </div>
        </div>
        <div className="w-full lg:w-2/3 mb-8 lg:pr-4 lg:pl-8" data-aos="fade-left">
          <h4 className="text-xl lg:text-2xl text-indigo-700 mb-2 mt-4 lg:mt-0">望廈迎賓館</h4>
          <div className="text-left mx-auto text-sm lg:text-base font-normal text-justify">
            <p className="mb-4">迎賓館（Pousada）是一個葡文詞彙，意思是“一個神聖的休息地方”。望廈迎賓館是一個充滿浪漫氣氛的精品酒店，既可令賓客享受澳門其中一個最恬靜的環境，也令旅遊學院的學生在一個充滿特色及溫情的地方上課和實習。</p>

            <div className="flex mt-8 flex-wrap">
              <div className="w-full md:w-1/2 md:pr-4">
                <Testimonial
                  title="望廈迎賓館歷年來榮獲的獎項及推介："
                  color="orange"
                  className="font-medium"
                >
                  <ul className="list-disc">
                    <li>《日本旅遊指南》星級推介，2005-2018</li>
                    <li>《米芝蓮香港．澳門指南》星級推介，2009-2018</li>
                    <li>TripAdvisor旅客最佳之選，2011-2018</li>
                    <li>TripAdvisor卓越獎，2012-2018</li>
                    <li>TripAdvisor中國最具性價比酒店第二位，2018 </li>
                    澳門環境保護局“澳門環保酒店獎金獎”，2017-2019
                  </ul>
                </Testimonial>
              </div>

              <div className="w-full md:w-1/2 md:pl-4">
                <Testimonial
                  title="望廈迎賓館大型修葺工程"
                  color="orange"
                  className="w-full font-medium mt-8 md:mt-0"
                >
                  <p>為了優化望廈迎賓館的服務設施，2018年1月迎賓館開展大型修葺工程，整個項目預計將在2019年底完成。考慮到一直以來迎賓館受到不同類型的賓客所愛戴，因此工程將保留迎賓館獨特的歷史風格並融入時尚的元素，相信經過是次大規模的修葺工程，將為賓客帶來嶄新的住宿體驗並感受更非凡的旅程。</p>
                </Testimonial>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      className="bg-banner-30 bg-center bg-cover py-12"
      style={{ backgroundImage: `url(/AnnualReport2017-2018/images/campus/5.1.4.jpg)` }}
    >
    </div>

    <div className="py-8 md:py-12" id="ift-educational-restaurant">
      <div className="container">
        <h2 className="text-3xl md:text-5xl text-orange-500 text-center mb-2" data-aos="fade-down">教學餐廳</h2>
        <div className="flex flex-row flex-wrap mt-8">
          <div className="w-full lg:w-2/3 flex" data-aos="fade-right" data-aos-delay={150}>
            <div className="text-left mx-auto text-sm lg:text-base lg:pr-8 font-normal text-justify">
              <p className="mb-4">在經驗豐富的導師指導及帶領下，學生可在教學餐廳獲得有關餐廳營運的豐富實踐經驗。</p>
              <p className="mb-4">餐廳融入現代的烹調技巧，餐單上亦提供極具澳門本土特色的土生菜，並全心支持有機種植和慢食文化，其中菜餚上使用的有機香草，均來自望廈校區的香草園。餐廳不時舉辦特別活動以推廣世界美食，同時也會推出季節性的菜單及聖誕節和情人節精選菜式，為美食愛好者帶來驚喜的味覺盛宴。</p>
              <p className="mb-4">學院餐飲團隊經常參加不同的培訓課程，以掌握酒吧和餐廳營運的最新趨勢。2017年9月5日至7日，學院餐飲部行政副經理黃育山及總廚李漢斯參加於香港會議展覽中心舉行的“香港餐飲展2017”。同年11月9日至11日，黃育山、餐飲服務課程主任班浩邦、餐桌主管Miguel Lanca及曾日昇也一同赴香港參加“第十屆香港國際美酒展2017”。</p>
              <p className="mb-4">澳門被聯合國教科文組織評選為創意城市美食之都，作為一流的旅遊及餐飲培訓機構，旅遊學院也肩負對外推廣澳門美食的責任。2018年5月15日至20日，總廚秦建基及唐潤強代表學院參加“活力澳門推廣週——福建福州”。2018年5月至6月，黃育山及總廚李漢斯更是代表學院參加以推廣澳門作為創意城市美食之都的系列活動，特別於5月31日至6月5日在意大利帕爾馬舉行的“City of Gastronomy Festival”。同年7月9日至20日，兩人還代表學院參加在佛得角舉行的“Kavala Fresk Feastival”美食推廣活動。所有活動都頗具成效。</p>
              <p>在美食之外，旅遊學院總廚譚光湖代表澳門特區政府旅遊局於2018年2月2日至11日，在日本北海道參加“第45屆國際雪雕比賽”，澳門隊榮獲第二名。</p>
            </div>
          </div>
          <div className="w-full lg:w-1/3 mt-8 lg:mt-0" data-aos="fade-left" data-aos-delay={150}>
            <div className="inset-0">
              <img src="/AnnualReport2017-2018/images/campus/IFT-Restaurant.jpg" alt="IFT" className="object-cover object-bottom h-full w-full shadow-xl rounded-sm" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="bg-gray-200 py-8" id="out-of-the-common-run">
      <div className="container">
        <h2 className="text-3xl md:text-5xl text-orange-500 text-center mb-2" data-aos="fade-down">嶄露頭角</h2>
        <div className="flex flex-row flex-wrap mt-8">
          <div className="w-full lg:w-1/3">
            <div className="inset-0" data-aos="fade-right" data-aos-delay={150}>
              <img src="/AnnualReport2017-2018/images/campus/5.1.6.jpg" alt="IFT" className="object-cover object-bottom h-full w-full shadow-xl rounded-sm" />
            </div>
          </div>
          <div className="w-full lg:w-2/3 flex mt-4 lg:mt-0" data-aos="fade-left" data-aos-delay={150}>
            <div className="text-left mx-auto text-sm lg:text-base lg:pl-8 font-normal text-justify">
              <p className="mb-4">由澳門廚藝協會主辦及旅遊學院協辦的“澳門青年廚師廚藝比賽”（Young Chef Competition），是廚藝專業學生嶄露頭角的試驗場。</p>
              <p>青年廚師比賽的每位參賽者均需要在三小時內製作頭盤、主菜和甜品。參賽者必須準備兩份，一份供評委品嚐，另一份評鑒擺盤技巧。2017年10月6日，兩名廚藝管理學士學位課程四年級學生參加了“第十屆澳門青年廚師廚藝比賽”，林志健同學更榮獲冠軍。</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="py-8 md:py-12">
      <div className="container">
        <div className="flex flex-row flex-wrap -mx-2 mb-8">
          <div className="w-full lg:w-4/5" data-aos="fade-right">
            <Bubble className="mx-2 mb-4"
              title=""
              subtitle="知識寶庫"
            >
              <div className="text-sm lg:text-base leading-relaxed font-normal text-justify">
                <p className="mb-4">旅遊學院致力創造優越的學習環境，滿足學生及教職員閱讀、汲取資訊以及終身學習的需求。學院設有兩所圖書館，分別設於望廈校園和氹仔校區。</p>
                <p>氹仔校區圖書館佔地700平方米，於2016年8月投入使用，該圖書館設有不同的閱覽區，通過可移動的家具，學生可以靈活地設定他們的學習環境，圖書館也提供電腦區及雜誌區等設施。與望廈校區的圖書館一樣，為讀者提供一個安靜、放鬆的學習和研究環境。</p>
              </div>
            </Bubble>
          </div>
          <div className="w-full lg:w-1/5 mb-4" data-aos="fade-left">
            <div className="mx-2 inset-0">
              <img src="/AnnualReport2017-2018/images/campus/5.2.1.jpg" alt="IFT" className="object-cover object-bottom h-full w-full" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="bg-gray-200 py-8 md:py-12 md:pb-16">
      <div className="container flex flex-wrap">
        <div className="w-full md:w-1/2 md:pr-4" data-aos="fade-right">
          <h4 className="text-xl md:text-2xl text-indigo-700 mb-2" data-aos="fade-right">與大灣區圖書館建立聯繫</h4>
          <div className="text-left mx-auto text-sm md:text-base font-normal text-justify">
            <p>由澳門大學圖書館發起、香港中文大學圖書館及中山大學圖書館附議的“粵港澳高校圖書館聯盟”於2017年6月正式成立。而首屆的粵港澳高校圖書館聯盟年會暨館長論壇於2017年12月13至14日在澳門大學舉行，12月14日首次全體成員館會議選出了12個理事單位。旅遊學院圖書館更入選為澳門地區首屆理事成員之一。聯盟主要合作領域包括館際互借、文獻傳遞、出版物交換、館員交流與培訓等。目的是打造“一小時圖書館圈”，深化三地學術交流和合作研究，並為“大灣區”發展規劃提供支援。</p>
          </div>
        </div>
        <div className="w-full md:w-1/2 md:pl-4 mt-8 md:mt-0" data-aos="fade-left">
          <h4 className="text-xl md:text-2xl text-indigo-700 mb-2">圖書館對外聯繫</h4>
          <div className="text-left mx-auto text-sm md:text-base font-normal text-justify">
            <p className="mb-4">澳門高校圖書館聯盟代表前往馬來西亞吉隆坡國際會議中心參加第84屆國際圖書館協會聯合會年會及考察馬來西亞高校圖書館，國際圖書館協會聯合會成立於1927年，是聯合各國圖書館協會、學會組成，是世界圖書館界最具權威及影響的非政府的專業性國際組織。現有約140個國家超過1,400個會員。本館於2014年開始成為該聯合會會員。該聯盟允許一所高等教育機構的學生從澳門其他8所高等教育機構的圖書館借閱圖書館資料。</p>
            <p>2016年，學院成為大中華地區首間聯合國世界旅遊組織（UNWTO）“出版物寄存圖書館計劃”的機構。該計劃旨在讓公眾更簡易地閱覽該組織出版的研究報告和其他出版刊物。</p>
          </div>
        </div>
      </div>
    </div>

    <div className="py-8 md:py-12">
      <div className="container">
        <IntroBox className="mx-2 text-sm md:text-base h-full"
          title=""
          image="/images/campus/5.2.3.jpg"
          textClassName="pl-0 md:pl-8"
        >
          <p>旅遊學院於開學禮當天舉行首次升國旗儀式，超過400名學生和教職員出席了升旗儀式，旨在提升對國家的認同感，培養愛國愛澳精神。</p>
          <p class="mt-4"><VideoButton url="https://player.youku.com/embed/XMzk3MTU0NjU4OA==" /></p>
        </IntroBox>
      </div>
    </div>
  </Layout>
)

export default IndexPage
